import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExchangeComponent } from './exchange.component';
import { BestRatesModule } from '@app/landing-page/components/best-rates/best-rates.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { TransactionCalculatorModule } from '@app/transactions/components/transaction-calculator/transaction-calculator.module';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { CoreModule } from '@app/core/core.module';
import { ExchangeRoutingModule } from '@app/transactions/pages/exchange/exchange-routing.module';
import { SystemsUpdatedService } from '@app/transactions/services/systems-updated.service';
import { RateStatsChartModule } from '@app/transactions/components/rate-stats-chart/rate-stats-chart.module';
import { SeriesChartModule } from '@app/core/components/series-chart/series-chart.module';
import { AnimatedBlurredCirclesModule } from '@app/core/components/animated-blurred-circles/animated-blurred-circles.module';
import { LandingPageModule } from '@app/landing-page/landing-page.module';
import { TranslateModule } from '@ngx-translate/core';
import { InfoBlockModule } from '@app/core/components/info-block/info-block.module';
import { BestPriceTablesModule } from './components/best-price-tables/best-price-tables.module';
import { CurrencyComparisonModule } from './components/currency-comparison/currency-comparison.module';
import { FlyerSaldoModule } from '@app/landing-social-proof/components/flyer-saldo/flyer-saldo.module';
import { FeeBannerModule } from './components/fee-banner/fee-banner.module';
import { SystemsRecommendationsModule } from './components/systems-recommendations/systems-recommendations.module';

@NgModule({
    declarations: [ExchangeComponent],
    imports: [
        CommonModule,
        ExchangeRoutingModule,
        BestRatesModule,
        MatButtonModule,
        FlexModule,
        InfoBlockModule,
        SeriesChartModule,
        SystemsRecommendationsModule,
        FeeBannerModule,
        FlyerSaldoModule,
        MatIconModule,
        TranslateModule,
        LandingPageModule,
        AnimatedBlurredCirclesModule,
        TransactionCalculatorModule,
        MatListModule,
        CoreModule,
        RateStatsChartModule,
        BestPriceTablesModule,
        CurrencyComparisonModule,
        FlexLayoutModule
    ],
    providers: [SystemsUpdatedService]
})
export class ExchangeModule {}
